<template>
  <div class="container box-cent">
    <div class="common-header-wrap">
      <mt-header :title="$t('Recharge Details')" class="common-header">
        <mt-button slot="left" icon="back" @click="onPage('index')"></mt-button>
      </mt-header>
    </div>

    <div class="pb-30" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="list-wrapper" v-if="recharge_list && recharge_list.length">
        <div class="container" v-for="(item, index) in recharge_list" :key="item.pdr_id" @click="goToPay(1, item.pdr_sn)">
          <div class="top-wrapper">
            <div class="left-wrapper">
              <label class="status">{{ item.pdr_payment_state_text }}</label>
              <label class="title">{{ $t('Recharge Order No.') }}: {{ item.pdr_sn }}</label>
            </div>
            <div class="right-wrapper">
              <label class="price">${{ item.pdr_amount }}</label>
              <label class="subtitle">{{ $t('Recharge Amount') }}</label>
            </div>
            <!-- <div class="top-line"></div> -->
          </div>
          <div class="center-wrapper" v-if="item.reason">
            <label class="desc" style="color: #FB2630;">{{ $t('Cause of failure') }}: {{ item.reason }}</label>
          </div>
          <div class="center-wrapper">
            <label class="desc">{{ $t('Creation Time') }}: {{ item.pdr_addtime_text }}</label>
          </div>
        </div>
      </div>
      <empty-record v-else-if="recharge_list && !recharge_list.length"></empty-record>
    </div>
    <div class='common-add-btn'>
      <div class="div ds-button-large" @click="goAdd">{{ $t('Recharge') }}</div>
    </div>
  </div>
</template>

<script>
import { getRechargeList, addRecharge } from '../../../api/memberRecharge'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  name: 'BalanceHistory',
  components: {
    EmptyRecord
  },
  data() {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      wrapperHeight: 0,

      recharge_list: false

    }
  },
  created() {
  },

  mounted() {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  methods: {
    onPage(v, val) {
        this.$emit('onPage', v, val)
    },
    goAdd() {
      let that = this
      MessageBox({
        $type: 'prompt',
        title: that.$t('MessageBox.Tips'),
        message: that.$t('MessageBox.recharge.pop'),
        confirmButtonText: that.$t('MessageBox.Confirm'),
        cancelButtonText: that.$t('MessageBox.Cancel'),
        showCancelButton: true,
        showInput: true,
      }).then(({ value, action }) => {
        if (action == 'confirm') {
          addRecharge(value).then(res => {

            if (res.code == 10000) {
              this.goToPay(0, res.result.pay_sn)
            } else {
              Toast(res.message)
            }

          }).catch(function (error) {
            Toast(error.message)
          })
        }
      }).catch(() => { })
    },
    goBack() {
      this.$router.go(-1)
    },
    goToPay(state, paySn) {
      if (state == 0) {
        this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: paySn, pay_type: 'pd_pay' } })
      }
    },
    loadMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getRechargeList(true)
      }
    },
    getRechargeList() {
      Indicator.open()

      getRechargeList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.list
        if (temp) {
          if (!this.recharge_list) {
            this.recharge_list = temp
          } else {
            this.recharge_list = this.recharge_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.common-add-btn {
  position: fixed;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  background-color: unset;
  .ds-button-large {
    background: #E7010C;
    padding: .1rem;
    border-radius: 1rem;
    text-align: center;
  }
}

.box-cent {
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}

.common-header {
  box-shadow: none;

  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.container {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.header {
  border-bottom: 1px solid #e8eaed;
}

.list-wrapper {
  margin: 0 .5rem;
  border-radius: 10px;
  border: 1px solid #e8eaed;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0 0 0.75rem 0;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }
  }

  .top-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
  }

  .left-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .right-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .status {
    font-size: $subFontSize;
    color: #5296db;
    margin-left: 0.75rem;
    margin-top: 0.65rem;
  }

  .title {
    font-size: $fontSize;
    color: #666666;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    margin-right: 0.5rem;
    margin-bottom: 0.2rem;
  }

  .price {
    font-size: $h1;
    color: $primaryColor;
    margin-right: 0.75rem;
    margin-top: 0.5rem;
    text-align: right;
  }

  .subtitle {
    // width: 4rem;
    font-size: $fontSize;
    color: #999999;
    margin-right: 0.75rem;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    text-align: right;
  }

  .top-line {
    position: absolute;
    left: 0.75rem;
    bottom: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaed;
  }

  .desc {
    color: #999999;
    font-size: $fontSize;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
  }

  .center-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    // border-bottom: 1px solid #e8eaed;
    padding-bottom: 0.25rem;
  }
}
</style>
